import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { Button } from './Button';
const services = [{
  icon: '🩺',
  title: 'Consultas Generales',
  desc: 'Chequeos de rutina, diagnósticos precisos y seguimiento personalizado para mantener a tu mascota en su mejor estado.',
  color: 'bg-primary'
}, {
  icon: '💉',
  title: 'Vacunación',
  desc: 'Plan de vacunas completo y desparasitación adaptado a la edad y estilo de vida de tu compañero.',
  color: 'bg-secondary'
}, {
  icon: '🏥',
  title: 'Cirugía',
  desc: 'Procedimientos seguros con monitoreo constante, quirófano equipado y el mejor cuidado post-operatorio.',
  color: 'bg-accent'
}, {
  icon: '🚨',
  title: 'Urgencias 24hs',
  desc: 'Atención inmediata cuando más lo necesitás. Equipo preparado para actuar rápido y salvar vidas.',
  color: 'bg-white'
}];
export const Services: React.FC = () => {
  return <section id="servicios" className="py-24 bg-white border-y-3 border-text relative overflow-hidden" data-id="element-134">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-135">
        <div className="absolute top-20 right-10 w-64 h-64 bg-bg rounded-full border-3 border-text opacity-50 transform translate-x-1/2" data-id="element-136"></div>
        <div className="absolute bottom-20 left-10 w-40 h-40 bg-accent rounded-full border-3 border-text opacity-50 transform -translate-x-1/2" data-id="element-137"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-138">
        <SectionHeading title="Todo lo que tu mascota necesita, en un solo lugar" data-id="element-139" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16 max-w-5xl mx-auto" data-id="element-140">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} whileHover={{
          scale: 1.03,
          y: -5
        }} className={`${service.color} border-3 border-text rounded-3xl p-8 neo-shadow-lg transition-all duration-300 flex flex-col sm:flex-row gap-6 items-start`} data-id="element-141">
              <div className="text-6xl bg-white border-3 border-text rounded-2xl w-24 h-24 flex-shrink-0 flex items-center justify-center neo-shadow-sm transform -rotate-3" data-id="element-142">
                {service.icon}
              </div>
              <div data-id="element-143">
                <h3 className="text-2xl font-black mb-3" data-id="element-144">{service.title}</h3>
                <p className="font-medium text-lg text-gray-800 leading-relaxed" data-id="element-145">
                  {service.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-146">
          <Button href="#contacto" variant="white" className="text-xl" data-id="element-147">
            Ver lista completa de servicios
          </Button>
        </div>
      </div>
    </section>;
};